export function getRiskFactorsTooltip(answer, isBadge) {
    let tooltipContent = [];

        if (isBadge && answer.displayanswercontext)
        {
            tooltipContent.push("" + answer.answer)       
        }

        tooltipContent.push(answer.notes);

        if (answer.questionHelpText)
        {
            tooltipContent.push("(" + answer.questionHelpText + ")");
        }

    return {tooltipLines: tooltipContent};
}
